import {HStack, VStack} from 'platform/foundation';

import {TestIdProps, suffixTestId} from 'shared/web';

import {WorkshopOverviewInteraction} from './types/WorkshopOverviewInteraction';
import {WorkshopOverviewSectionState} from './types/WorkshopOverviewTileConfig';
import {WorkshopOverviewSectionLabel} from './WorkshopOverviewSectionLabel';
import {WorkshopOverviewTileGrid} from './WorkshopOverviewTileGrid';

interface WorkshopOverviewCompactProps extends TestIdProps {
  sections: WorkshopOverviewSectionState[];
  interaction: WorkshopOverviewInteraction;
}

export function WorkshopOverviewCompact(props: WorkshopOverviewCompactProps) {
  return (
    <VStack height="100%" spacing={2}>
      <HStack spacing={4} align="center" wrap>
        {props.sections.map((sectionState) => (
          <WorkshopOverviewSectionLabel
            key={sectionState.section}
            section={sectionState.section}
            tiles={sectionState.tiles}
            isLoading={props.interaction.isLoading}
            density="compact"
            data-testid={suffixTestId(`workshopOverview-${sectionState.section}`, props)}
          />
        ))}
      </HStack>
      <VStack spacing={2} grow={1}>
        {props.sections.map((sectionState) => (
          <WorkshopOverviewTileGrid
            key={sectionState.section}
            section={sectionState.section}
            tiles={sectionState.tiles}
            density="compact"
            interaction={props.interaction}
            grow={sectionState.tiles.length}
            data-testid={suffixTestId(`workshopOverview-${sectionState.section}`, props)}
          />
        ))}
      </VStack>
    </VStack>
  );
}
